/* eslint-disable max-len */
import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { McRcModule } from '../remote-control-ng';
import { RemoteControlEmbedIncidentComponent } from 'xsmodules/remote-control/remote-control-view/embed-incident/remote-control-embed-incident.component';
import { FileExplorerComponent } from 'xsmodules/remote-control/remote-control-view/file-explorer/file-explorer.component';
import { FileManagerActionBarComponent } from 'xsmodules/remote-control/remote-control-view/file-manager-action-bar/file-manager-action-bar.component';
import { FileManagerDeleteItemComponent } from 'xsmodules/remote-control/remote-control-view/file-manager-delete-item/file-manager-delete-item.component';
import { FileManagerRenameItemComponent } from 'xsmodules/remote-control/remote-control-view/file-manager-rename-item/file-manager-rename-item.component';
import { FileManagerStatusCenterComponent } from 'xsmodules/remote-control/remote-control-view/file-manager-status-center/file-manager-status-center.component';
import { FileManagerUploadContentDialogComponent } from 'xsmodules/remote-control/remote-control-view/file-manager-upload-content-dialog/file-manager-upload-content-dialog.component';
import { RcExecuteScriptComponent } from 'xsmodules/remote-control/remote-control-view/rc-execute-script/rc-execute-script.component';
import { RcScreenshotComponent } from 'xsmodules/remote-control/remote-control-view/rc-screenshot/rc-screenshot.component';
import { RcTabSelectorComponent } from 'xsmodules/remote-control/remote-control-view/rc-tab-selector/rc-tab-selector.component';
import { RemoteControlService } from 'xsmodules/remote-control/services/remote-control.service';
import { DeviceStateRegistryService } from 'app/modules/remote-control/services/device-state-registry.service';
import { FileManagerService } from 'xsmodules/remote-control/services/file-manager.service';
import { RemoteControlUserPreferencesDialogComponent } from 'xsmodules/remote-control/remote-control-view/remote-control-user-preferences/rc-user-preferences-dialog/rc-user-preferences-dialog.component';
import { RemoteControlUserPreferencesComponent } from 'xsmodules/remote-control/remote-control-view/remote-control-user-preferences/remote-control-user-preferences.component';
import { RemoteControlUserPreferencesService } from 'xsmodules/remote-control/remote-control-view/remote-control-user-preferences/remote-control-user-preferences.service';
import { RcTabViewComponent } from 'xsmodules/remote-control/remote-control-view/rc-tab-view/rc-tab-view.component';
import { RcTitleBarComponent } from 'xsmodules/remote-control/remote-control-view/rc-title-bar/rc-title-bar.component';
import { RcViewV2Component } from 'xsmodules/remote-control/remote-control-view/rc-view-v2/rc-view-v2.component';
import { ToolbarPopoverComponent } from 'xsmodules/remote-control/remote-control-view/toolbar-popover/toolbar-popover.component';
import { RcZoomComponent } from 'xsmodules/remote-control/remote-control-view/rc-zoom/rc-zoom.component';
import { ZoomControllerService } from 'xsmodules/remote-control/services/zoom-controller.service';
import { RemoteControlCanvasComponent } from 'xsmodules/remote-control/remote-control-view/remote-control-canvas/remote-control-canvas.component';
import { RemoteControlDeviceLogsSelectorComponent } from 'xsmodules/remote-control/remote-control-view/remote-control-device-logs-selector/remote-control-device-logs-selector.component';
import { RemoteControlVideoRecordingPopoverComponent } from 'xsmodules/remote-control/remote-control-view/video-recording-popover/video-recording-popover.component';
import { FileManagerButtonsComponent } from 'xsmodules/remote-control/remote-control-view/file-manager-buttons/file-manager-buttons.component';
import { DeviceButtonsComponent } from 'xsmodules/remote-control/remote-control-view/device-buttons/device-buttons.component';
import { RemoteControlExtendedToolbarComponent } from 'xsmodules/remote-control/remote-control-view/extended-toolbar/extended-toolbar.component';
import { RemoteControlAnnotationsToolbarComponent } from 'xsmodules/remote-control/remote-control-view/annotations-toolbar/annotations-toolbar.component';
import { RemoteControlAnnotationsService } from 'xsmodules/remote-control/services/annotations.service';
import { RemoteControlVideoRecordingToolbarComponent } from 'xsmodules/remote-control/remote-control-view/video-recording-toolbar/video-recording-toolbar.component';
import { RemoteControlVideoRecordingService } from 'xsmodules/remote-control/services/video-recording.service';
import { RemoteControlDeviceRotationComponent } from 'xsmodules/remote-control/remote-control-view/remote-control-device-rotation/remote-control-device-rotation.component';
import { RemoteControlVideoRecordingTimerComponent } from 'xsmodules/remote-control/remote-control-view/video-recording-timer/video-recording-timer.component';
import { DropDownListComponent } from 'xsmodules/remote-control/remote-control-view/drop-down-list/drop-down-list.component';
import { RemoteControlScreenPanelComponent } from 'xsmodules/remote-control/remote-control-screen-panel/remote-control-screen-panel.component';
import { TaskManagerComponent } from 'xsmodules/remote-control/remote-control-view/task-manager/task-manager.component';
import { TaskDetailsComponent } from 'xsmodules/remote-control/remote-control-view/task-manager/task-details/task-details.component';
import { TaskDetailsAndroidComponent } from 'xsmodules/remote-control/remote-control-view/task-manager/task-details/task-details-android/task-details-android.component';
import { TaskDetailsWindowsComponent } from 'xsmodules/remote-control/remote-control-view/task-manager/task-details/task-details-window/task-details-windows.component';
import { TaskManagerService } from 'xsmodules/remote-control/services/task-manager.service';
import { CanvasDirectiveDirective } from 'xsmodules/remote-control/services/canvas-directive.directive';
import { RemoteControlSessionService } from 'xsmodules/remote-control/services/session.service';
import { RcLogsService } from 'xsmodules/remote-control/services/rc-logs.service';
import { RemoteControlTabService } from 'xsmodules/remote-control/services/rc-tab.service';
import { DeviceService } from '@nx-fe/services';
import { SharedComponentsModule } from 'app/shared/shared-components.module';
import { PipesModule } from '@nx-fe/pipes';
import { SignalRModule } from '../signalr/signalr.module';
import { RcDeviceService } from './services/rc-device-service';
import { SelectModule } from '@soti/select';
import { PopupModule } from '@soti/popup';
import { BrowseFilefolderDragdropContentComponent } from './remote-control-view/browse-filefolder-dragdrop-content/browse-filefolder-dragdrop-content.component';
import { MultiDisplayPopupComponent } from './remote-control-view/multi-display-popup/multi-display-popup.component';
import { RcFileSystemService } from '../remote-control-ng/context/fileSystem';
import { RcDeviceStateChangeDetectService } from './services/rc-device-change.service';
import { TooltipModule } from '@soti/tooltip';
import { MultiDisplaySelectionViewComponent } from './remote-control-view/multi-display-selection/multi-display-selection-view/multi-display-selection-view.component';

@NgModule({
  declarations: [
    RemoteControlUserPreferencesComponent,
    RemoteControlUserPreferencesDialogComponent,
    DeviceButtonsComponent,
    FileManagerButtonsComponent,
    FileManagerActionBarComponent,
    RemoteControlExtendedToolbarComponent,
    RemoteControlAnnotationsToolbarComponent,
    RemoteControlVideoRecordingToolbarComponent,
    RemoteControlVideoRecordingPopoverComponent,
    RemoteControlDeviceRotationComponent,
    RemoteControlVideoRecordingTimerComponent,
    CanvasDirectiveDirective,
    RemoteControlEmbedIncidentComponent,
    ToolbarPopoverComponent,
    FileManagerRenameItemComponent,
    RemoteControlDeviceLogsSelectorComponent,
    FileManagerDeleteItemComponent,
    FileManagerUploadContentDialogComponent,
    FileManagerStatusCenterComponent,
    DropDownListComponent,
    RemoteControlScreenPanelComponent,
    FileExplorerComponent,
    RcViewV2Component,
    RemoteControlCanvasComponent,
    RcTabViewComponent,
    RcTabSelectorComponent,
    RcZoomComponent,
    TaskManagerComponent,
    TaskDetailsComponent,
    TaskDetailsAndroidComponent,
    TaskDetailsWindowsComponent,
    RcTitleBarComponent,
    RcExecuteScriptComponent,
    RcScreenshotComponent,
    BrowseFilefolderDragdropContentComponent,
    MultiDisplayPopupComponent,
    MultiDisplaySelectionViewComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    //SharedModule,
    SharedComponentsModule,
    SelectModule,
    MatRadioModule,
    MatDialogModule,
    MatSliderModule,
    MatSelectModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatMenuModule,
    PopupModule,
    McRcModule,
    PipesModule,
    SignalRModule,
    TooltipModule
  ],
  providers: [
    RemoteControlUserPreferencesService,
    RemoteControlAnnotationsService,
    RemoteControlSessionService,
    RemoteControlVideoRecordingService,
    RemoteControlService,
    DeviceStateRegistryService,
    FileManagerService,
    TaskManagerService,
    RcLogsService,
    RemoteControlTabService,
    ZoomControllerService,
    RcDeviceService,
    DeviceService,
    RcFileSystemService,
    RcDeviceStateChangeDetectService,
  ],
  exports: [
    RemoteControlDeviceLogsSelectorComponent,
    RemoteControlEmbedIncidentComponent,
    FileManagerRenameItemComponent,
    FileManagerDeleteItemComponent,
    RemoteControlScreenPanelComponent,
    RcViewV2Component,
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class RemoteControlModule {}
